import script from "./AppTagSelectorList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTagSelectorList.vue?vue&type=script&setup=true&lang=ts"

import "./AppTagSelectorList.vue?vue&type=style&index=0&id=a037902c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a037902c"]])

export default __exports__